import React, { Component } from 'react';

class ContainerMid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            collMid: [
                {
                    id: 1,
                    // subtitle: 'Chapter 4',
                    title: 'Affordable Knowledge',
                    text: 'Our e-books are priced to ensure that quality education and insights are accessible to everyone.'
                }
            ]
        }
    }
    render() {
        return (
            <div className="chapter-list border-right-0">
                {
                    this.state.collMid.map((data, i) => (
                        <div className="chapter-item" key={i}>
                            <h4><span>{data.subtitle} </span> {data.title}</h4>
                            <p>{data.text} </p>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ContainerMid;
